import React, { useEffect, useState } from 'react'
import { IconPlusBg } from '../../../../../../../../../../shared/IconsComponent/icons'
import AddNewCognitiveStatus from './AddNewCognitiveStatus';
import { enumUtil } from '../../../../../../../../../../../utils/Enum';
import { ServerRequestProtected } from '../../../../../../../../../../../utils/ServerDataRequest';

const CognitiveStatus = (props) => {
    let { setSaveCognitiveStatusData, cognitiveStatusData, setObservationsData } = props;
    const API_URL = enumUtil.controller.General

    const [isOpenCognitiveStatus, setIsOpenCognitiveStatus] = useState(false);
    const [cognitiveStatusID, setCognitiveStatusID] = useState();
    let CognitiveStatus_Modal = {
        CognitiveStatusValuesID: "",
        CognitiveStatusValues: "",
        CognitiveDate: "",
        Notes:  ""
    }
    const [mainCognitiveStatusModal, setMainCognitiveStatusModal] = useState(CognitiveStatus_Modal);
    const [cognitiveStatusDDData, setCognitiveStatusDDData] = useState([]);

    useEffect(() => {
      ServerRequestProtected(API_URL + "/DropDown", 'post', {
        "TableName": enumUtil.enumAPITableName.COGNITIVESTATUS,
      }).then((response) => {
        setCognitiveStatusDDData(response);
      }).catch((error) => {
      })
    }, [])

    const AddCognitiveStatus = (ID, prob) => {
        setCognitiveStatusID(ID)
        setMainCognitiveStatusModal(prob);
        setIsOpenCognitiveStatus(prev => !prev);
    }
    const CloseCognitiveStatus = () => {
        setIsOpenCognitiveStatus(false)
        setMainCognitiveStatusModal(CognitiveStatus_Modal);
        setCognitiveStatusID();
    }
    
    const handleCognitiveDelete = (item, indexToRemove) => {
        const { CognitiveStatusID, recordNoClient } = item;

        // 1. Remove from ObservationsData (view state)
        setObservationsData(prev => {
            const updatedCognitiveStatus = prev.CognitiveStatus.filter((_, idx) => idx !== indexToRemove);
            return { ...prev, CognitiveStatus: updatedCognitiveStatus };
        });

        // 2. Update saveCognitiveStatusData (save state)
        setSaveCognitiveStatusData(prev => {
            if (CognitiveStatusID) {
                const exists = prev.some(cs => cs.CognitiveStatusID === CognitiveStatusID);

                if (exists) {
                    // Already in save state → mark as deleted
                    return prev.map(cs =>
                        cs.CognitiveStatusID === CognitiveStatusID
                            ? { ...cs, Deleted: "true" }
                            : cs
                    );
                } else {
                    // Not in save state yet → add a deleted entry
                    return [
                        ...prev,
                        {
                            CognitiveStatusID,
                            EncounterID: item.EncounterID,
                            Deleted: "true",
                        },
                    ];
                }
            } else if (recordNoClient) {
                // Local-only entry → remove it completely
                return prev.filter(cs => cs.recordNoClient !== recordNoClient);
            } else {
                return prev;
            }
        });
    };

    let PopupScreen = "";
    if (isOpenCognitiveStatus) {
        PopupScreen = 
        <AddNewCognitiveStatus 
            isOpenCognitiveStatus={isOpenCognitiveStatus} 
            cognitiveStatusID={cognitiveStatusID}
            onClose={CloseCognitiveStatus} 
            setObservationsData={setObservationsData}
            CognitiveStatus_Modal={CognitiveStatus_Modal}
            mainCognitiveStatusModal={mainCognitiveStatusModal} setMainCognitiveStatusModal={setMainCognitiveStatusModal}
            setSaveCognitiveStatusData={setSaveCognitiveStatusData}
            cognitiveStatusDDData={cognitiveStatusDDData}
            // onDeleteCognitiveStatus={DeleteCognitiveStatus} 
            // setIsRecordSaved={setIsRecordSaved}
        />
    }
    console.log("saveCogntiveStatusData cognitiveStatusData cognitiveStatusData",cognitiveStatusData)
  return (
        <div className="">
            {PopupScreen}
            <div className="d-flex align-items-center gap-2 mb-2 px-1-5">
                <p className="heading">Cognitive Status</p>
                <div onClick={() => AddCognitiveStatus(null, CognitiveStatus_Modal)}><IconPlusBg /></div>
            </div>
            <div className="d-flex flex-column gap-1 ar_content hover-scrollbar px-1-5">
                {cognitiveStatusData?.length > 0 ? 
                    (cognitiveStatusData.map((cognitiveStatusItem, index)=> {
                        let display  = cognitiveStatusItem?.CognitiveStatusValues?.split("-").map(part => part.trim());
                    return (
                    <div className="d-flex align-items-center justify-content-between">
                        <div className='d-flex align-items-center gap-1'>
                            <p className='text'>
                                <span className='validate-color cursor-pointer' onClick={() => AddCognitiveStatus(cognitiveStatusItem.CognitiveStatusValuesID, cognitiveStatusItem)}>
                                {display?.[1] || 'N/A'}</span> - {display?.[0] || 'N/A'} 
                            </p>
                            <span className='text light-clrs'>|</span>
                            <p className='text'><span className='font-m'>Date:</span> {cognitiveStatusItem.CognitiveDate}</p>
                        </div>
                        <i className='icon-x-cros fs-20 dark-clr' onClick={() => handleCognitiveDelete(cognitiveStatusItem, index)}></i>
                    </div>)
                })) :
                (<div className="d-flex flex-column gap-2 ar_content hover-scrollbar px-1-5">
                    <p className='text light-clrs'>No coginitive status recorded</p>
                </div>)}
                {/* <div className="d-flex align-items-center justify-content-between">
                    <div className='d-flex align-items-center gap-1'>
                        <p className='text'><span className='validate-color'>Hysterical Annesia</span> - 923824    </p>
                        <span className='text light-clrs'>|</span>
                        <p className='text'><span className='font-m'>Date:</span> 8/5/2025</p>
                    </div>
                    <i className='icon-x-cros fs-20 dark-clr'></i>
                </div> */}
            </div>
        </div>
  )
}

export default CognitiveStatus


    // const handleDocumentDelete = (item, indexToRemove) => {
    //     const { PatientDocumentID, recordNoClient } = item;

    //     // Remove from EncounterDocument list by index
    //     setAdditionalInfoData(prev => {
    //         const updatedEncounterDocument = prev.EncounterDocument.filter((_, idx) => idx !== indexToRemove);
    //         return { ...prev, EncounterDocument: updatedEncounterDocument };
    //     });
    //     // Update saveDocumentData accordingly
    //     setSaveDocumentData(prev => {
    //         if (PatientDocumentID) {
    //             const exists = prev.some(doc => doc.PatientDocumentID === PatientDocumentID);

    //             if (exists) {
    //                 //  Update it to mark as deleted
    //                 return prev.map(doc =>
    //                     doc.PatientDocumentID === PatientDocumentID
    //                         ? { ...doc, Deleted: "true" }
    //                         : doc
    //                 );
    //             } else {
    //                 //  Push a new deleted object if it doesn't exist yet
    //                 return [
    //                     ...prev,
    //                     {
    //                         PatientDocumentID,
    //                         EncounterID: item.EncounterID,
    //                         Deleted: "true",
    //                     },
    //                 ];
    //             }
    //         } else if (recordNoClient) {
    //             //  Remove unsaved local doc entirely
    //             return prev.filter(doc => doc.recordNoClient !== recordNoClient);
    //         } else {
    //             return prev;
    //         }
    //     });
    // }
